import React, { useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { getStrategy, updateStrategyStatus } from "./strategyStorage";
import "../AlgoTrading.css";

const StrategyDetails = () => {
  const { strategyId } = useParams();
  const navigate = useNavigate();
  const [strategy, setStrategy] = useState(() => getStrategy(strategyId));
  if (!strategy) return <Navigate to="/strategies" replace />;

  const status = (value) => {
    updateStrategyStatus(strategy.id, value);
    setStrategy({ ...strategy, status: value });
  };

  return <main className="algo-page">
    <header className="algo-page-heading"><div><button className="algo-back" onClick={() => navigate("/strategies")}><i className="fa fa-arrow-left"></i></button><h1>{strategy.name}</h1><p>{strategy.id} · {strategy.brokerName}</p></div><span className={`algo-badge algo-badge--${strategy.status.toLowerCase()}`}>{strategy.status}</span></header>
    <section className="algo-details-grid">
      <article className="algo-content-card"><h2>Configuration</h2><div className="algo-review">{Object.entries({
        Broker: strategy.brokerName, Symbol: `${strategy.exchange}:${strategy.symbol}`, Quantity: strategy.quantity,
        Product: strategy.productType, Mode: strategy.tradingMode, "Time Frame": strategy.timeFrame,
        "Stop Loss": `₹${strategy.stopLoss || 0}`, Target: `₹${strategy.target || 0}`,
      }).map(([key, value]) => <div key={key}><span>{key}</span><strong>{value || "—"}</strong></div>)}</div></article>
      <aside className="algo-content-card algo-action-panel"><h2>Controls</h2><button className="algo-primary" onClick={() => status("ACTIVE")}><i className="fa fa-play"></i> Start</button><button className="algo-secondary" onClick={() => status("PAUSED")}><i className="fa fa-pause"></i> Pause</button><button className="algo-danger" onClick={() => status("STOPPED")}><i className="fa fa-stop"></i> Stop</button></aside>
    </section>
    <section className="algo-kpi-grid"><article><span>Today’s P&amp;L</span><strong className="algo-positive">₹0.00</strong></article><article><span>Total Orders</span><strong>0</strong></article><article><span>Open Positions</span><strong>0</strong></article></section>
  </main>;
};

export default StrategyDetails;
